import React from 'react';
import TimeZoneUtils from './../../../baseApp/shared/utils/DateTimeUtils'
import {I18n} from 'react-redux-i18n';
import SearchForm from './../../../baseApp/shared/components/searchForm/SearchForm';
import ReactHighcharts from 'highcharts-react-official';
import HighCharts from 'highcharts';
import {appModules} from './../../../baseApp/roles/components/UserHasPermission';
import {parkingGraphSearchFields} from "./SearchFields";

const getOptions = loading => ({
    chart: {
        type: 'spline',
        marginTop: 60,
        marginRight: 50,
        events: {
            render: function () {
                this.reflow();
            }
        }
    },
    title: {
        text: ''
    },
    xAxis: {
        type: 'datetime'
    },
    yAxis: {
        title: {
            text: I18n.t('parking.page.graph.numberOfSlots')
        },
        min: 0,
        max: 100,
        labels: {
            format: '{value}%'
        }
    },
    tooltip: {
        shared: true,
        enabled: !loading
    },
    plotOptions: {
        line: {
            marker: {
                enabled: false
            }
        },
        series: {
            threshold: null,
            turboThreshold:5000,
            states: {
                inactive: {
                    opacity: 0.8
                }
            }
        }
    },
    series: [],
    time: {
        useUTC: false,
        //  timezone: UserSessionService.getCurrentUserTimezone()
        timezone: TimeZoneUtils.getUserTimeZone()
    }
});

class ParkingSlotGraph extends React.Component {

    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }


    componentWillReceiveProps(nextProps) {
        const { chart } = this.refs.chartRef;
        const { loading } = this.props.graphProps;
        const { loading : nextLoading } = nextProps.graphProps;

        if(loading && !nextLoading) {
            chart.hideLoading();
        } else if (!loading && nextLoading) {
            chart.showLoading();
        }
    }

    render() {
        const {
            graphProps: {
                data = [],
                loading = false
            },

            handleSearchFieldChange,

            searchFieldsValues = {},

            searchFieldsData= {},

            handleSearchSubmit = () => { },

            handleSearchClear = () => {}
        } = this.props;
        return (
            <div className="graph-info-wrapper page_background">
                <SearchForm
                    content={parkingGraphSearchFields(searchFieldsValues, searchFieldsData)}
                    handleFieldChange={handleSearchFieldChange}
                    handleClear={handleSearchClear}
                    handleSubmit={handleSearchSubmit}
                    hideAddButton={true}
                    hideUniversalSearch={true}
                    appModule={appModules.PARKING}
                />
                <ReactHighcharts
                    highcharts={HighCharts}
                    options={{
                        ...getOptions(loading),
                        series: loading? [] : data,
                    }}
                    ref={"chartRef"}
                />
            </div>
        );
    }
}

export default ParkingSlotGraph;